import React from 'react';
import './LogoExplosion.css';

const EyeIcon = () => (
    <svg width="30" height="30" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 16C17.64 16 6.121 26.36 2 32c4.121 5.64 15.64 16 30 16s25.879-10.36 30-16c-4.121-5.64-15.64-16-30-16z" stroke="#00d1ff" strokeWidth="4" fill="none"/>
        <circle cx="32" cy="32" r="8" fill="#00d1ff"/>
    </svg>
);

const LogoExplosion = () => {
    return (
        <div className="logo-explosion" id="home">
            <img src="/assets/logo.png" alt="Логотип" className="logo" />
            <div className="bot-redirect">
                <a href="https://t.me/istoneyebot" target="_blank" rel="noopener noreferrer" className="redirect-btn">
                    Запустить бота
                </a>
            </div>
            <div className="icon icon1"><EyeIcon /></div>
            <div className="icon icon2"><EyeIcon /></div>
            <div className="icon icon3"><EyeIcon /></div>
            <div className="icon icon4"><EyeIcon /></div>
            <div className="icon icon5"><EyeIcon /></div>
        </div>
    );
};

export default LogoExplosion;
